export default "/_next/static/chunks/fonts/MinionPro-Regular-dff1d1d25e5b4f784a241de3c87d7a93.woff";